module.exports = __webpack_public_path__ + "img/sidebar-2.3b306195.jpg";